import { Controller } from "@hotwired/stimulus"

// Tracks whether the form it's attached to has unsaved edits, by comparing the form's current serialized
// state against a snapshot taken once everything has initialized. Comparing state (rather than listening
// for input/change) catches edits made programmatically without events too — nested_form_controller
// adding/removing items and number_controller's non-bubbling quantity change. Only fields whose form
// owner is this form are serialized, so the inline resolution/exchange editors (their fields are
// associated via the HTML `form=` attribute with their own standalone forms) never mark this form dirty.
export default class extends Controller {
  connect() {
    // Snapshot on the next frame so sibling controllers (number, nested-form) have set their initial
    // values first; before then isDirty() is conservatively false.
    this.initial = null
    this.frame = requestAnimationFrame(() => {
      this.initial = this.serialize()
    })
  }

  disconnect() {
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  isDirty() {
    return this.initial !== null && this.serialize() !== this.initial
  }

  // Before something that reloads the page and would discard this form's unsaved edits: asks when there are
  // any, and returns whether to go ahead.
  confirmDiscard(message) {
    return !this.isDirty() || window.confirm(message)
  }

  // Click action for a submit button inside this form that submits a standalone form (via `form=`), with the
  // message in data-dirty-form-message-param.
  guardSubmit(event) {
    if (!this.confirmDiscard(event.params.message)) event.preventDefault()
  }

  serialize() {
    const entries = []
    for (const [key, value] of new FormData(this.element).entries()) {
      entries.push(`${key}=${value instanceof File ? value.name : value}`)
    }
    return entries.sort().join("&")
  }
}
